import React from 'react';
import { cn } from '../../utils/cn';

/**
 * SegmentedControl — pattern signature piste 8.
 * Bouton actif en bg-ink/text-cream, fond bg-cream-2.
 *
 *   <SegmentedControl
 *     value={status}
 *     onChange={setStatus}
 *     options={[
 *       { value: 'all',   label: 'Tous',       count: 42 },
 *       { value: 'pub',   label: 'Publiés',    count: 28 },
 *       { value: 'draft', label: 'Brouillons', count: 7 },
 *     ]}
 *   />
 */

const SIZES = {
  sm: 'h-7 text-[12px]',
  md: 'h-8 text-[12.5px]',
  lg: 'h-9 text-[13px]',
};

export function SegmentedControl({
  value,
  onChange,
  options = [],
  size = 'md',
  fullWidth = false,
  vertical = false,
  className,
  ariaLabel,
}) {
  const h = SIZES[size] || SIZES.md;
  return (
    <div
      role="tablist"
      aria-orientation={vertical ? 'vertical' : 'horizontal'}
      aria-label={ariaLabel}
      className={cn(
        'bg-cream-2 rounded-md p-0.5 border border-cream-3',
        vertical
          ? 'flex flex-col w-full gap-0.5'
          : fullWidth
            ? 'flex w-full'
            : 'inline-flex',
        className,
      )}
    >
      {options.map((opt) => {
        const isActive = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => !isActive && onChange?.(opt.value)}
            className={cn(
              'rounded font-semibold transition-colors inline-flex items-center gap-1.5 whitespace-nowrap',
              vertical
                ? 'w-full justify-start px-3'
                : fullWidth
                  ? 'flex-1 justify-center px-2 min-w-0'
                  : 'justify-center px-3',
              h,
              isActive
                ? 'bg-ink text-cream'
                : 'text-mute hover:text-ink hover:bg-cream-3/40',
            )}
          >
            {opt.icon && <span className="shrink-0">{opt.icon}</span>}
            <span>{opt.label}</span>
            {opt.count != null && (
              <span
                className={cn(
                  'font-mono text-[11px] tabular-nums',
                  isActive ? 'text-cream/65' : 'text-mute-2',
                )}
              >
                · {String(opt.count).padStart(2, '0')}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default SegmentedControl;
